import { createAction } from '@reduxjs/toolkit';
import { responseFailed } from './error';
import { showHideLoader } from './loader';

const getCompleteCase = createAction('case/getCompleteCase', function prepare(caseId) {
  return {
    payload: {
      endPoint: `banks/:bankId/cases/personal-loan/${caseId}/completed`,
      method: 'get',
      isPaasApi: true,
      addHeader: true,
      success: getCompleteCaseSuccess,
      failure: responseFailed,
      version: '1.2.0',
      useEnvTag: true
    }
  };
});

const getCompleteCaseSuccess = (response) => (dispatch) => {
  dispatch(getCompleteCaseSuccessResponse(response));
  dispatch(showHideLoader(false));
};

const getCompleteCaseSuccessResponse = createAction(
  'case/getCompleteCaseSuccessResponse',
  function prepare(response) {
    return {
      payload: response
    };
  }
);
export { getCompleteCase, getCompleteCaseSuccess, getCompleteCaseSuccessResponse };
